import { _marketingFreeFeatureIds, _salesFreeFeatureIds, _serviceFreeFeatureIds, _operationsFreeFeatureIds, _cmsFreeFeatureIds } from './_MerchandiseFeatures';
import Hubs from './Hubs';
export default {
  [Hubs.HUB_MARKETING]: _marketingFreeFeatureIds,
  [Hubs.HUB_SALES]: _salesFreeFeatureIds,
  [Hubs.HUB_SERVICE]: _serviceFreeFeatureIds,
  [Hubs.HUB_OPERATIONS]: _operationsFreeFeatureIds,
  [Hubs.HUB_CMS]: _cmsFreeFeatureIds
};